/**
 * Runs `task` once the browser is idle, or within 2 s, off the first paint.
 * Safari has no `requestIdleCallback`: the next macrotask stands in.
 */
export const runWhenIdle = (task: () => void) =>
  typeof window.requestIdleCallback === "function"
    ? window.requestIdleCallback(task, { timeout: 2000 })
    : setTimeout(task, 0);
